export default "__VITE_ASSET__CDAiGxLp__"